import { render, staticRenderFns } from "./Payout.vue?vue&type=template&id=006cd77c&"
import script from "./Payout.vue?vue&type=script&lang=js&"
export * from "./Payout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports